// @flow

import { camelCase, snakeCase } from 'lodash';

type ChangeCase = (string, ?any) => string;
type Predicate = (key: string) => boolean;

const defaultPredicate: Predicate = key => !key.startsWith('_');

export const changeKeysDeepWith = (
  changeCase: ChangeCase,
  predicate: Predicate = defaultPredicate
) => {
  const changeKeysDeep = (input: any) => {
    if (!input || typeof input !== 'object') {
      return input;
    }
    if (Array.isArray(input)) {
      return input.map(changeKeysDeep);
    }
    return Object.entries(input).reduce((cased, [key, val]) => {
      const maybeChangeKey = predicate(key) ? changeCase(key, val) : key;
      cased[maybeChangeKey] = changeKeysDeep(val);
      return cased;
    }, {});
  };
  return changeKeysDeep;
};

export const camelCaseKeysDeep = changeKeysDeepWith(camelCase);
export const snakeCaseKeysDeep = changeKeysDeepWith(snakeCase);
